module.exports = __webpack_public_path__ + "static/media/contextualinquiry.23cfe9ad.pdf";